import $ from 'jquery';
import gsap from 'gsap';

/**
 * Hero Slider JS
 */

let screenWidth = $(window).outerWidth();
const mobileWidth = 1023; // The breakpoint to switch functionality

function setSizes() {
    screenWidth = $(window).outerWidth();
}
setSizes();
$(window).on('resize', () => { setSizes() });

/**
 * Individual Slide
 */
class HeroSlide {

    constructor(el) {
        this.el = el;
        this.content = el.find('.heroSlide__content');
        // this.title = el.data('title');
        // this.image = el.data('image');
        this.isActive = false;
        this.activeSlideClass = 'heroSlide--active';
        // this.mobileNav = el.find('.heroSlide__navBar');
        // this.mobileNavHeight = this.mobileNav[0].getBoundingClientRect().height;
        this.tl = gsap.timeline({repeatRefresh: true, paused:true });
    }

    getData = (name) => this.el.data(name) ? this.el.data(name) : null;


    // Animation timeline setup
    setupAnimation = () => {
        const slide = this;
        if ( screenWidth > mobileWidth ) {
            // Desktop Animations

            // Reveal
            slide.tl.addLabel('startReveal');

            slide.tl.to(slide.el, {
                opacity: 1,
                duration: 0
            });
            slide.tl.from(slide.content.children(), {
                opacity: 0,
                x: -100,
                duration: 1.5,
                ease: 'power4.out',
                stagger: 0.3
            });

            slide.tl.addLabel('endReveal');
            slide.tl.addPause('endReveal');

            // Hiding
            slide.tl.addLabel('startHide');
            slide.tl.to(slide.el, {
                opacity: 0
            });
            slide.tl.addLabel('endHide');
            slide.tl.addPause('endHide');

        } else {
            // Mobile Animations
        }
    }

    // Reveal animation
    reveal = () => {
        const slide = this;
        slide.isActive = true;
        slide.el.addClass(slide.activeSlideClass);
        slide.tl.play('startReveal');
    }

    // Hide animation
    hide = () => {
        const slide = this;
        slide.isActive = false;
        slide.el.removeClass(slide.activeSlideClass);
        slide.tl.play('startHide');
    }

    // Adjust for screen resizes
    resize = () => {
        if ( screenWidth > mobileWidth ) {
            this.el.css('padding-top', headerHeight + 'px');
        } else {
            this.mobileNavHeight = this.mobileNav.outerHeight();
        }
    }

    // Set up default slide settings
    init = ( active ) => {
        const slide = this;

        if ( screenWidth > mobileWidth ) {
            gsap.set(slide.el, {
                opacity: 0,
                position: 'absolute'
            }, 0);
        } else {
        }

        if ( active ) {
            slide.reveal();
        }
    }

}



/**
 * Main Slider Class
 */
class HeroSlider {

    constructor(el) {
        this.el = el;
        this.innerWrapper = el.find('.heroSlider__inner');
        this.slides= [];
        this.navItems = [];
        this.navEl = el.find('.heroSlider__nav');
        this.activeNavClass = 'heroNavItem--active';
        this.height = 0; // Get the slider height from the tallest slide
        this.duration = 10; // Slide duration in seconds
        this.isAutoplaying = true; // Whether the slider is in autoplay mode or not
        this.isMobile = false;
    }

    // Adjust for screen resizes
    resize = () => {
        const slider = this;
    }

    /**
     * Slide functions
     */
    getSlides = () => this.slides;
    addSlide = (slide, i) => {
        const slider = this;
        slider.slides.push(slide);
        slider.addNavItem(slide.getData('title'), slide.getData('image'), slide.getData('link'), i);

    };

    // Reveal a slide
    revealSlide = (slide) => {
        slide.reveal();
    }

    // Hide a slide
    hideSlide = (slide) => {
        slide.hide();
    }

    // Switch slides
    switchSlides = (newIndex) => {
        const oldSlide = this.slides.find((el) => el.isActive);
        this.revealSlide(this.slides[newIndex]);
        this.setActiveNavItem(newIndex);
        // Find the next item to animate
        const nextIndex = newIndex + 1 == this.slides.length ? 0 : newIndex + 1;
        this.animateNavIndicator(nextIndex);
        if ( oldSlide ) {
            this.hideSlide(oldSlide);
            this.resetAnimatedNavIndicator(oldSlide.el.index());
        }
    } 


    /**
     * Navigation functions
     */

    // Add an item to the navigation list
    addNavItem = (title, image, link, index) => {
        const slider = this;
        const titleStr = title ? `<span class="heroNavItem__title">${title}</span>` : ``;
        const imageStr = image ? `--img: url(${image});` : ``;
        const linkStr = link ? link : 'javascript:void(0)';
        const animationStr = `<span class="heroNavItem__indicator"></span>`;
        const el = $('<a href="' + linkStr + '" class="heroNavItem" data-nav-index="' + index + '" style="' + imageStr + '">' + animationStr + titleStr + '</a>');
        slider.navItems.push({ 
            title, 
            index, 
            el
        });

        // Attach click event to switch slides
        // Pause the autoplay if the user clicks manually
        el.on('click', (event) => { 
            if ( screenWidth > mobileWidth ) {
                event.preventDefault();
                slider.pauseAutoplay();
                slider.switchSlides(index);
            }
         });
    }

    // Animate navItem Indicator (Desktop)
    animateNavIndicator = (index) => {
        const slider = this;
        // If we're not autoplaying or on mobile, don't animate anything
        if ( !slider.isAutoplaying ) return;

        // Else, animate
        const navItem = slider.navItems[index];
        let indicator = navItem.el.find('.heroNavItem__indicator');
        
        gsap.set(indicator, {
            opacity: 1
        });
        gsap.to(indicator, {
            height: '100%',
            duration: 10,
            ease: 'linear',
            onComplete: () => {
                if ( slider.isAutoplaying ) slider.switchSlides(index);
            },
        });

    }

    // Reset the animated navItem svg
    resetAnimatedNavIndicator = (index) => {
        const slider = this;

        const navItem = slider.navItems[index];
        let indicator = navItem.el.find('.heroNavItem__indicator');

        gsap.to(indicator, {
            opacity: '0',
            duration: 0.5,
            ease: 'linear',
            onComplete: () => {
                gsap.set(indicator, {
                    height: '0%',
                });
            }
        });
    }

    // Create desktop navigation list
    createNavList = () => {
        const slider = this;
        slider.navItems.forEach((item, i) => {
            slider.navEl.append(item.el);
        });
    }

    // Set navigation item as active
    setActiveNavItem = (newIndex) => {
        const slider = this;
        const newNavItem = slider.navItems[newIndex];
        slider.navItems.forEach((navItem, i) => {
            if ( navItem.el.hasClass(slider.activeNavClass) ) {
                navItem.el.removeClass(slider.activeNavClass);
            }
        });
        newNavItem.el.addClass(slider.activeNavClass);
    }

    /**
     * Autoplay
     */
    startAutoplay = () => {
        this.animateNavIndicator(1);
    }

    pauseAutoplay = () => {
        this.isAutoplaying = false;
        for (let i = 0; i < this.slides.length; i++) {
            this.resetAnimatedNavIndicator(i);
        }
    }


    /**
     * Init Settings
     */
    init() {
        const slider = this;

        // Initialize our slide objects
        const $slides = this.el.find('.heroSlide');
        $slides.each(function(i) {
            const slide = new HeroSlide($(this));
            slide.init(i == 0 ? true : false);
            slider.addSlide(slide, i);
        });

        // Set up animations in a separate loop after all the slides have been initialized
        this.slides.forEach((slide, i) => {
            slide.setupAnimation();
        });

        // Create our desktop navigation
        this.createNavList();
        this.setActiveNavItem(0);

        if ( screenWidth > mobileWidth ) {
            this.isMobile = false;

            // Get the slider height from the tallest slide
            const slideHeight = slider.slides.reduce( (prev, current) => {
                return prev > current.el.outerHeight() ? prev : current.el.outerHeight() 
            });
            const slidePadding = 128;
            slider.height = slideHeight + slidePadding;

            // Adjust navs to match slider height
            slider.el.get(0).style.setProperty("--sliderHeight", slider.height + 'px');

            // Start autoplay
            this.startAutoplay();
            
        } else {
            // Set up mobile styles
        }


        // // Add resize events
        // $(window).on('resize', () => slider.resize());

    }

}

export default HeroSlider;